<script>
    import { onMount } from "svelte";
    import { activateUserAccount } from '/public/services/users/users';
    import { fade } from 'svelte/transition';

    let working = true;

    let activated = false;

    export let params;

    let hash = params.hash;

    onMount(() => {
        activateUserAccount(hash).then(res => {
            working = false;

            activated = res.success;
        });
    });
</script>

<main>
    <div class="row justify-content-center mt-3 mb-3">
        <div class="col-sm-10 col-md-6 col-lg-4">
            <div class="card">
                <div class="card-header">
                    Account activation
                </div>
                <div class="card-body">
                    {#if working === true}

                        <div in:fade>
                            <h4>
                                <span class="ajax-ball-loader"></span> Activating your account
                            </h4>
                        </div>
                        
                    {:else}

                        {#if activated === false}

                            <div class="alert alert-warning clearfix mb-3" in:fade>
                                <h4 class='float-start me-2'>
                                    <span class="fas fa-exclamation-circle"></span>
                                </h4>
                                Unable to activate your account
                            </div>

                        {:else}

                            <section in:fade>
                                <div class="alert alert-primary clearfix mb-3">
                                    <h4 class='float-start me-2'>
                                        <span class="fas fa-check-circle"></span>
                                    </h4>
                                    Your account has been activated.
                                </div>
                                <div class="text-center">
                                    <a href="#/login" class="btn btn-primary btn-block mt-3 mb-3">
                                        <span class="fas fa-sign-in-alt"></span> Login
                                    </a>
                                </div>
                            </section>

                        {/if}

                    {/if}
                </div>
            </div>
        </div>
    </div>
</main>
